module.exports = __webpack_public_path__ + "assets/img/logo.1e38c637.png";